export enum ExternalPositionType {
  CompoundDebtPosition = '0',
  UniswapV3LiquidityPosition = '1',
  AaveV2DebtPosition = '2',
  LiquityDebtPosition = '3',
  ConvexVotingPosition = '4',
  TheGraphDelegationPosition = '5',
  MapleLiquidityPosition = '6',
  ArbitraryLoanPosition = '7',
  NotionalV2Position = '8',
  KilnStakingPosition = '9',
  SolvV2BondBuyerPosition = '10',
  SolvV2BondIssuerPosition = '11',
}
